import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Sparkles, ClipboardCheck, MapPin, Camera, Heart } from 'lucide-react';
import { useEventDialog } from '../context/EventDialogContext';

const ModalNav = ({ active }) => {
  const navigate = useNavigate();
  const { openInspiration, openRSVP, closeAll } = useEventDialog();

  const goHome = () => {
    closeAll();
    navigate('/');
  };

  const goContact = () => {
    closeAll();
    navigate('/contact');
  };

  const goPhotos = () => {
    closeAll();
    navigate('/photos');
  };

  const goRemerciement = () => {
    closeAll();
    navigate('/remerciement');
  };

  const items = [
  { key: 'home', label: 'Accueil', icon: Home, onClick: goHome },
  { key: 'inspiration', label: 'Inspiration', icon: Sparkles, onClick: openInspiration },
  { key: 'rsvp', label: 'RSVP', icon: ClipboardCheck, onClick: openRSVP },
  { key: 'contact', label: "Contact et Lieu", icon: MapPin, onClick: goContact },
  { key: 'photos', label: 'Photos', icon: Camera, onClick: goPhotos },
  { key: 'remerciement', label: 'Remerciement', icon: Heart, onClick: goRemerciement }];


  return (
    <div
      data-testid="modal-nav"
      className="sticky top-0 z-10 bg-gradient-to-b from-black via-black to-black/95 backdrop-blur-md border-b-2 border-orange-600/40 px-4 py-3">

      <nav className="flex items-center justify-center gap-1 sm:gap-2 flex-wrap">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              onClick={item.onClick}
              data-testid={`modal-nav-${item.key}`}
              className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full text-sm sm:text-base font-bold transition-all duration-300 ${
              isActive ?
              'bg-gradient-to-r from-orange-600 to-amber-600 text-white shadow-lg shadow-orange-500/40 scale-105' :
              'text-gray-300 hover:text-orange-400 hover:bg-orange-600/10 border border-transparent hover:border-orange-600/40'}`
              }>

              <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>{item.label}</span>
            </button>);

        })}
      </nav>
    </div>);

};

export default ModalNav;